import * as CallTranscriber from '../helpers/calling/CallTranscriber'
import hark from 'hark'
import Sagas from '../helpers/Sagas'
import { WidgetActions } from '../stores/MainStore'
import { VariableCallingActions } from '../stores/VariableCallingStore'
import { LocalAudioTrack } from "twilio-video";
import { initializeAwsTranscriber, closeAwsTranscriber} from '../helpers/aws-transcriber'

const { GlobalState } = require('reflux')

import { v4 } from 'uuid'

const CALLING_COLOR = '#bada55'

export const colorLog = (
	c: Parameters<typeof console['log']>[0],
	category: string | undefined = undefined,
	info: Parameters<typeof console['log']>[1] = undefined,
	color = CALLING_COLOR
) => {
	console.log(
		`%${category ? `[${category}]` : ''}${c}`,
		`color: ${color}`,
		info
	)
}

export const createNormalizedMediaTracks = (
	localId: string,
	constraints: MediaStreamConstraints,
	cb?: (v: any, t: any) => void, 
	transcribe = true
) => {

	return new Promise<MediaStream>((res, err) => {
		(navigator as any).getUserMedia(
			constraints,
			(stream: any) => {
				const audio = stream.getAudioTracks()?.[0]
				if(audio) {
					let transcriptionAudio = null
					const voiceAudio = setupSpeakingAndVolumeDetectionOnTrack(localId, audio)
					if(transcribe) transcriptionAudio = initializeTranscriptionOnTrack(localId, audio)
					if(cb) {
						cb(voiceAudio, transcriptionAudio)
					}
				}
				res(stream)
			},
			err
		)
	})
}

export interface MediaStreamTrackWithTimesliceSpeaking
	extends MediaStreamTrack {
	userSpokenInTimeslice?: boolean

	// Ensure idempotency
	speechDetectionInitialized?: boolean
	transcriptionInitialized?: boolean
}

export const setupSpeakingAndVolumeDetectionOnTrack = (
	id: string,
	track: MediaStreamTrackWithTimesliceSpeaking
) => {
	if (track.speechDetectionInitialized) {
		return
	}
	const speechEvents = hark(new MediaStream([track]))
	speechEvents.on('volume_change', (decibals) =>
		VariableCallingActions.PeerVolumeChange(id, decibals)
	)
	speechEvents.on('speaking', () => {
		track.userSpokenInTimeslice = true
		VariableCallingActions.SetActiveSpeaker(id)
	})
	return speechEvents
}

export const initializeTranscriptionOnTrack = (
	id: string,
	track: MediaStreamTrackWithTimesliceSpeaking
) => {
	if (track.transcriptionInitialized) {
		return
	}
	console.log('initializing transcription now')

	const speechEvents = hark(new MediaStream([track]))
	speechEvents.on('volume_change', (decibals) => {
		VariableCallingActions.PeerVolumeChange(id, decibals)
	})
	speechEvents.on('speaking', () => (track.userSpokenInTimeslice = true))

	CallTranscriber.createClient(
		track,
		// Callback when transcription results are returned
		(message_transcription: string) => {
            const { transcribe } = GlobalState.main.db_meeting.settings;
			if (!track.enabled || track.muted) {
				return
			}

            if(!transcribe) return
			const raw_transcription = {
				text: message_transcription,
				timestamp: Date.now(),
                t_id: v4()
			}
            //console.log('raw => ',raw_transcription)
			WidgetActions.TranscriptionResult(raw_transcription)
		},
		// If clientside transcription isn't supported, emit recording to backend
		async (blob: Blob) => {
			if (!track.enabled || track.muted) {
				return
			}
			// If the user hasn't spoken in the timeslice we return to save $$$
			if (!track.userSpokenInTimeslice) {
				Sagas.Clients.Emit('main', 'transcription-blob')
				return
			} else {
				// Reset if the user has spoken

				track.userSpokenInTimeslice = false
			}
			const file = await blobtobase64(blob)
			Sagas.Clients.Emit('main', 'transcription-blob', file)
		}
	)
	// CallTranscriber.beginRecognition()

	track.addEventListener('ended', () => {
		CallTranscriber.stopRecognition()
		speechEvents.stop()
	})
	track.addEventListener('mute', () => {
		CallTranscriber.stopRecognition()
		speechEvents.suspend()
	})
	track.addEventListener('unmute', () => {
		CallTranscriber.beginRecognition()
		speechEvents.resume()
	})

	return speechEvents
}

function blobtobase64(blob: Blob) {
	return new Promise((res, rej) => {
		const reader = new FileReader()
		reader.onload = function () {
			const dataUrl = reader.result
			const base64 = dataUrl
				? typeof dataUrl !== 'string'
					? dataUrl
					: dataUrl.split(',')[1]
				: ''
			res(base64)
		}
		reader.readAsDataURL(blob)
	})
}

export const initializeTranscription = (
	audioTrack: LocalAudioTrack
) => {
	const track: MediaStreamTrackWithTimesliceSpeaking = audioTrack.mediaStreamTrack
    initializeAwsTranscriber(WidgetActions.TranscriptionResult, v4, GlobalState.main.db_meeting.settings.transcribe, track)

	track.addEventListener('ended', () => {
		////console.log(track, 'ended')
		CallTranscriber.stopRecognition()
        closeAwsTranscriber()
	})
	track.addEventListener('mute', () => {
		////console.log(track, 'mute')
		CallTranscriber.stopRecognition()
        closeAwsTranscriber()
	})
	track.addEventListener('unmute', () => {
		////console.log(track, 'unmute')
		CallTranscriber.beginRecognition()
	})

	audioTrack.on('enabled', () => {
		////console.log('enabled')
		CallTranscriber.beginRecognition()
	})

	audioTrack.on('started', () => {
		////console.log('started')
		CallTranscriber.beginRecognition()
	})

	audioTrack.on('disabled', () => {
		////console.log('disabled')
		// CallTranscriber.stopRecognition()
	})

	audioTrack.on('stopped', () => {
		////console.log('stopped')
		CallTranscriber.stopRecognition()
        closeAwsTranscriber()
	})

	return {
		audioTrack,
		mediaStreamTrack: track,
		CallTranscriber
	}
}



	// CallTranscriber.createClient(
	// 	track,
	// 	// Callback when transcription results are returned
	// 	(message_transcription: string) => {
    //         const { transcribe } = GlobalState.main.db_meeting.settings;
	// 		if (!track.enabled || track.muted) {
	// 			return
	// 		}
    //         // //console.log(GlobalState)
    //         if(!transcribe) return
	// 		const raw_transcription = {
	// 			text: message_transcription,
	// 			timestamp: Date.now(),
    //             t_id: v4()
	// 		}

    //         console.log(' raw #2 =>',raw_transcription)
	// 		WidgetActions.TranscriptionResult(raw_transcription)
	// 	},
	// 	// If clientside transcription isn't supported, emit recording to backend
	// 	async (blob: Blob) => {
	// 		if (!track.enabled || track.muted) {
	// 			return
	// 		}
	// 		// If the user hasn't spoken in the timeslice we return to save $$$
	// 		if (!track.userSpokenInTimeslice) {
	// 			Sagas.Clients.Emit('main', 'transcription-blob')
	// 			return
	// 		} else {
	// 			// Reset if the user has spoken
	// 			track.userSpokenInTimeslice = false
	// 		}
	// 		const file = await blobtobase64(blob)
	// 		Sagas.Clients.Emit('main', 'transcription-blob', file)
	// 	}
	// )
	// CallTranscriber.beginRecognition()